import { render, staticRenderFns } from "./CLtkLogo.vue?vue&type=template&id=290a3398&scoped=true"
import script from "./CLtkLogo.vue?vue&type=script&lang=ts"
export * from "./CLtkLogo.vue?vue&type=script&lang=ts"
import style0 from "./CLtkLogo.vue?vue&type=style&index=0&id=290a3398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a3398",
  null
  
)

export default component.exports